import { 
  GET_GAME_DETAIL,
  GET_GAME_ERROR,
  GET_GAME_REWARD,
  UPDATE_FLAG_IS_STOP_WHEEL,
  UPDATE_COUPON_URL
 } from "../actions/types"

const initialState = {
  transactionId: "",
  gameDetail: "",
  rewards: [],
  messageType: "",
  messageError: "",
  isStopWheel: false,
  reward: {
    reId: 0,
    reName: "",
    reQty: 0,
    reBalance: 0,
    reUsed: 0,
    reType: 1,
    reCampaignId: "",
    reChanceRate: "",
    reIsActive: true,
    reIsRedeem: false,
    startDate: "",
    endDate: "",
    reRedeemCode: "",
    reImgId: "",
    imageDisplay: "",
    backgroundColor: "#FFFFFF"
  },
  couponUrl: ""
}

const gameLandingPage = (state = initialState, action) => {
  const { type, payload } = action

  switch (type) {
    case GET_GAME_ERROR:
      return {
        ...state,
        messageType: payload.messageType,
        messageError: payload.messageError
      }
    case GET_GAME_DETAIL:
      return {
        ...state,
        transactionId: payload.transactionId,
        rewards: payload.reward,
        gameDetail: payload.gameDetail // Correctly assign the updated gameDetail state
      }
    case GET_GAME_REWARD:
      return {
        ...state,
        reward: {
          ...state.reward,
          reId: payload.reId,
          reName: payload.reName,
          reQty: payload.reQty,
          reBalance: payload.reBalance,
          reUsed: payload.reUsed,
          reType: payload.reType,
          reCampaignId: payload.reCampaignId,
          reChanceRate: payload.reChanceRate,
          reIsActive: payload.reIsActive,
          reIsRedeem: payload.reIsRedeem,
          startDate: payload.startDate,
          endDate: payload.endDate,
          reRedeemCode: payload.reRedeemCode,
          reImgId: payload.reImgId,
          imageDisplay: payload.imageDisplay,
          backgroundColor: payload.backgroundColor
        }
      }
    case UPDATE_FLAG_IS_STOP_WHEEL:
      return {
        ...state,
        isStopWheel: payload
      }
    case UPDATE_COUPON_URL:
      return {
        ...state,
        couponUrl: payload
      }
    default:
      return state
  }
}

export default gameLandingPage